import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent, implementFunction } from "../../../../framework/core/mvvm/module_base";
import SettingView from "./setting_view";
import ModuleManager from '../../../../framework/core/module_manager';
import LocalStorage from "../../../../manager/local_storage";
import AudioManager from "../../../../manager/audio_manager";
import Utility from "../../../../utility/utility";
import LoginModule from "../login/login_module";
import SceneManager from "../../../../manager/scene_manager";
import { GameManager } from '../../../../manager/game_manager';
import EventManager from "../../../../manager/event_manager";
import LanguageManager from "../../../../manager/language_manager";
import ModelData, { IUserData } from "../../../public/model_data";
import SdkStorage from "../../../../sdk/SdkStorage";
import Test from "../test/test";
import bindingCellphone from '../bindingCellphone/bindingCellphone';
import invitationCountdownManager from '../../../../manager/invitationCountdown_manager';
import AppData from '../../../public/const/app_data';

const { ccclass, property } = cc._decorator;

@ccclass
@moduleInit("Setting")
export default class Setting extends ModuleBase<SettingView, null> {

    isClick = false
    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/hall/module/setting/hall_setting";
        this.viewType = SettingView;
        this.modelType = null;
        this.needAnim = true
        this.needViewMask = true
        this.clickAnywhereClose = true;
    }
    mobileNumber: string = "";
    testClickTimes :number = 0;
    protected onButtonClickName(name: string) {
        switch (name) {
            case "closeBtn":
                this.hide()
                break;
            default:
                break;
        }
    }
    @bindButtonClickEvent("btnCancel")
    onButtonCancel() {
        this.hide()
    }
    @bindButtonClickEvent("btnSure")
    onButtonSure() {
        Utility.reportEffect("game_setting_logout")
        let self = this
        GameManager.logout()
        ModuleManager.instance.showModule(LoginModule, "", () => {
            ModuleManager.instance.hideModule("LoginModule")
            self.hide()
            EventManager.instance.dispatch("hall_show_type", "HideHall", true)
            invitationCountdownManager.instance.resetTime();
            self.doScheduleOnce(() => {
                SceneManager.gotoAuth(true)
            }, 0.25)

        })

    }
    @bindButtonClickEvent("openBinding")
    onButtonOpenBinding() {
        ModuleManager.instance.showModule(bindingCellphone,{ loginBinding : false});
    }
    @bindButtonClickEvent("btnTest",true)
    onButtonTest() {
        let isDevelop = LocalStorage.getNumber("__isDevelopTestMode",0)
        if(isDevelop > 0){
            ModuleManager.instance.showModule<Test>(Test)
        }else{
            this.testClickTimes += 1;
            if(this.testClickTimes > 30){
                ModuleManager.instance.showModule<Test>(Test)
            }
        }
    }
    onInit() {
        let self = this
        this.isClick = false

        // this.getUserBindingDataByUID();
        // 0 - 开  1 - 闭
        this.view.musicToggle.node.on('toggle', function (event: cc.Toggle) {
            if (this.isClick) {
                Utility.playButtonSound()
            }
            let toggle = event;
            let bgNode = self.view.musicToggle.node.getChildByName("Background")
            let markNode = self.view.musicToggle.node.getChildByName("checkmark")
            if (toggle.isChecked == true) {
                bgNode.active = false
                markNode.active = true
                AudioManager.instance.setMusicOpen(true)
                AudioManager.instance.resumeMusic()
            } else {
                bgNode.active = true
                markNode.active = false
                AudioManager.instance.setMusicOpen(false)
                AudioManager.instance.pauseMusic()
            }
        }, this);

        this.view.soundToggle.node.on('toggle', function (event: cc.Toggle) {
            if (this.isClick) {
                Utility.playButtonSound()
            }
            let bgNode = self.view.soundToggle.node.getChildByName("Background")
            let markNode = self.view.soundToggle.node.getChildByName("checkmark")
            let toggle = event;
            if (toggle.isChecked == true) {
                bgNode.active = false
                markNode.active = true
                AudioManager.instance.setSoundOpen(true)
            } else {
                bgNode.active = true
                markNode.active = false
                AudioManager.instance.setSoundOpen(false)
            }
        }, this);

        this.view.musicSlider.node.on("slide", function (event) {
            let musicValue = self.view.musicSlider.progress
            AudioManager.instance.setMusicVolume(musicValue)
            this.view.musicProgressBar.progress = musicValue;
        }, this)

        this.view.soundSlider.node.on("slide", function (event) {
            let soundValue = self.view.soundSlider.progress
            AudioManager.instance.setSoundVolume(soundValue)
            this.view.soundProgressBar.progress = soundValue;
        }, this)
    }

    onShow() {
        // if (this.view.btnTest) {
        //     this.view.btnTest.active = AppData.testMode
        // }
        this.isClick = false
        if (AudioManager.instance.isMusicOpen()) {
            this.view.musicToggle.check();
        } else {
            this.view.musicToggle.uncheck();
        }

        if (AudioManager.instance.isSoundOpen()) {
            this.view.soundToggle.check();
        } else {
            this.view.soundToggle.uncheck();
        }
        this.mobileNumber = "";
        this.view.soundSlider.progress = cc.audioEngine.getEffectsVolume()
        this.view.soundProgressBar.progress = cc.audioEngine.getEffectsVolume()
        this.view.musicSlider.progress = cc.audioEngine.getMusicVolume()
        this.view.musicProgressBar.progress = cc.audioEngine.getMusicVolume()
        this.view.labVersion.string = "v" + GameManager.getAppAssetVersion()
        this.isClick = true
        this.view.labGameServerCenterVersion.node.active = AppData.serverCenter != null
        if (AppData.serverCenter) {
            this.view.labGameServerCenterVersion.string = "v" + AppData.serverCenter
        }
    }

    @implementFunction('onUserDataUpdate')
    protected on_userDataUpdate(data: IUserData){        
        this.view.nameTxt.string = data.name
        // if (data.mobile && data.mobile != "") {
        //     this.view.openBinding.active = false
        //     this.view.bindingCellphone.string = data.mobile;
        // } else {
        //     this.view.openBinding.active = true;
        // }
    }
    onHide(){
        this.testClickTimes = 0
    }
}
